import {apiConfig} from '@stencil/hotels-config';
import Megatron from '@stencil/megatron';

type HotelCancellationPolicyDataType = {
  cancelPolicy: string[];
  // notice: string[];
  // pah_flat: boolean;
  // cancel_policy_rule: Array<{
  //   policy_time: string;
  //   start_day: string;
  //   data_description: string;
  //   description: string;
  //   charges: number;
  //   charges_type: string;
  //   end_day: number;
  // }>;
  // only_pah_flag: boolean;
  // n: string[];
  // crystal: boolean;
  // fcdt: string;
  // additional_hotel_policy: {
  //   "Hotel Policy": Array<any>
  // };
  // cp: string[];
  // hotelPolicy: string[];
};

type CancellationPolicyPropsTypes = {
  forwardParams: {
    prgen: string;
    vhid: string;
    ps: string; // format – "6000|4494|539"
    ts: string; // "2020-01-07T12:10:38"
    hctx: string;
    hctxty: string;
    srctx: string;
  };
  roomPriceCode: string;
  offercode: string;
  vendor: string;
  paymode: number;
  roomTypeCode: string;
  checkinYYYYMMDD: string;
  checkoutYYYYMMDD: string;
  cityCode: string;
  hotelCode: string;
  paxString: string;
};

type FetchCancellationPolicyDataReturnType = [HotelCancellationPolicyDataType | null, Error | null];

async function hotelsPolicyApi(cancellationPolicyProps: CancellationPolicyPropsTypes) {
  // const allCancellationPolicyPropsArePresent = commonUtils.allFirstLevelObjectKeysAreNonNullable(
  //   cancellationPolicyProps,
  // );

  // if (!allCancellationPolicyPropsArePresent) {
  //   return [cancellationPolicyDefault, null] as FetchCancellationPolicyDataReturnType;
  // }

  const {
    hotelCode,
    roomTypeCode,
    roomPriceCode,
    offercode,
    forwardParams,
    vendor,
    cityCode,
    checkinYYYYMMDD,
    checkoutYYYYMMDD,
    paxString,
    paymode,
  } = cancellationPolicyProps;
  const cancellationPolicyQueryParams = {
    hotelCode: `hc=${hotelCode}`,
    roomTypeCode: `rtc=${roomTypeCode}`,
    roomPriceCode: `rpc=${roomPriceCode}`,
    offerCode: `offercode=${offercode}`,
    fwdParams: `fwdParams=${JSON.stringify(forwardParams)}`,
    vendor: `v=${vendor}`,
    sth: `strQry=hotels-${cityCode}-${checkinYYYYMMDD}-${checkoutYYYYMMDD}-${paxString}`,
    payMode: `pay_mode=${paymode}`,
  };

  const queryStringForCancellationUrl = Object.keys(cancellationPolicyQueryParams)
    .filter(sensibleQueryParamName => cancellationPolicyQueryParams[sensibleQueryParamName].length)
    .reduce((accumulatedQueryString, sensibleQueryParamName, index) => {
      const toAdd = cancellationPolicyQueryParams[sensibleQueryParamName];
      const prefix = index === 0 ? '?' : '&';

      return `${accumulatedQueryString}${prefix}${toAdd}`;
    }, '');

  const cancellationPolicyUrl = `/${apiConfig.detailsAPIEndPoints.cancellationPolicy}/${queryStringForCancellationUrl}`;

  let hotelCancellationPolicyData: HotelCancellationPolicyDataType | null = null;
  let error = null;

  try {
    const response = await Megatron({
      name: 'cancellationPolicy',
      type: 'GET',
      url: cancellationPolicyUrl,
    });
    hotelCancellationPolicyData = response;
  } catch (e) {
    error = e;
    console.error(e);
  }

  const ret: FetchCancellationPolicyDataReturnType = [hotelCancellationPolicyData, error];

  return ret;
}

export default hotelsPolicyApi;
